import { ApprovalConsiderationAnnounceSixComponent } from "../../../components/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceSixComponent";
// import { ApprovalConsiderationAnnounceFiveComponent } from "../../../components/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceFiveComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function ApprovalConsiderationAnnounceSixContainer() {
    const titleName = "รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (ชอ.4-2)";
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <ApprovalConsiderationAnnounceSixComponent />
            <Footer />
        </div>
    )
}